module.exports = __webpack_public_path__ + "static/media/IMG_8036.13ccb383.jpg";